import { SSOError, SSOParams } from '@localstack/types';

// Cognito's `error_description` when our GitHub userinfo endpoint (`/v1/oauth/github/user-info`) rejects a sign-in,
// most commonly because the email of the linked LocalStack account isn't verified on GitHub. Cognito doesn't
// forward our error, so the same description also shows up for other failures of that endpoint.
export const COGNITO_USER_INFO_ERROR = 'username attribute mapping required';

export const GITHUB_USER_INFO_ERROR_MESSAGE =
  "We couldn't sign you in with GitHub. Make sure the email address of your LocalStack account is added and " +
  'verified in your GitHub account (Settings → Emails), then try again. If it already is, please try again in a ' +
  'few minutes.';

const isPublicGitHubIdp = ({ orgId, idpName }: SSOParams): boolean => orgId === 'public' && idpName === 'github';

/**
 * Replaces generic SSO error messages with more helpful ones, based on the identity provider the flow was started
 * with. The popup that receives the error doesn't know the identity provider, so this runs in the opener.
 */
export const formatSSOError = (error: SSOError, ssoParams: Optional<SSOParams>): SSOError => {
  if (ssoParams && isPublicGitHubIdp(ssoParams) && error.code?.includes(COGNITO_USER_INFO_ERROR)) {
    return { ...error, message: GITHUB_USER_INFO_ERROR_MESSAGE };
  }

  return error;
};
